/** 表单弹窗: 标题 + 表单字段 + 错误提示 + 取消/提交 (回车即提交) */
import { useId, type FormEvent, type ReactNode } from "react";
import { Alert, Button, Dialog } from "@/components/ui";

export function FormDialog({
  title, description, pending, submitText, pendingText, cancelText = "取消", onClose, onSubmit, err, children,
}: {
  title: string;
  description?: ReactNode;
  cancelText?: string;
  pending: boolean;
  submitText: string;
  pendingText: string;
  onClose: () => void;
  onSubmit: () => void;
  err: string | null;
  children: ReactNode;
}) {
  const formId = useId();
  const submit = (e: FormEvent) => {
    e.preventDefault();
    onSubmit();
  };
  return (
    <Dialog
      open
      onClose={onClose}
      title={title}
      description={description}
      footer={
        <>
          <Button variant="outline" onClick={onClose}>{cancelText}</Button>
          <Button type="submit" form={formId} loading={pending}>{pending ? pendingText : submitText}</Button>
        </>
      }
    >
      <form id={formId} onSubmit={submit} className="space-y-3" noValidate>
        {children}
        {err && <Alert>{err}</Alert>}
      </form>
    </Dialog>
  );
}
